import React from 'react'
import { toast } from 'react-toastify'
import { Stack } from '@mui/system'
import { Button, Container, Typography, OutlinedInput, InputAdornment } from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import SearchIcon from '@mui/icons-material/Search'
import { FullScreenLoader, ApplicationTable } from '../../components'
import { ApplicationForm } from './ApplicationForm'

import { IApplication, IUpdateApplicationStatusRequest } from '../../types'
import {
  useGetApplicationListQuery,
  useUpdateApplicationStatusMutation,
} from '../../redux/api/applicationApi'

export function ApplicationManagementPage() {
  const { isLoading, data, refetch } = useGetApplicationListQuery(null)
  const [updateStatus, { isSuccess, isError, isLoading: loading, error }] =
    useUpdateApplicationStatusMutation()
  const [searchKey, setSearchKey] = React.useState<string>('')

  React.useEffect(() => {
    if (isSuccess) {
      toast.success('Success!')
      refetch()
    }
    if (isError) {
      if (Array.isArray((error as any)?.data?.error)) {
        const errors = error as any
        errors?.data.error.forEach((el: any) =>
          toast.error(el?.message ?? 'Something Failed!', {
            position: 'top-right',
          }),
        )
      } else {
        toast.error((error as any)?.data?.message ?? 'Something Failed!', {
          position: 'top-right',
        })
      }
    }
  }, [loading])
  const [isVisible, setIsVisible] = React.useState(false)
  const [editableApplication, setEditableApplication] = React.useState<IApplication | undefined>()

  if (isLoading || !data || loading) {
    return <FullScreenLoader />
  }

  const handleEditable = (data: IApplication) => {
    setEditableApplication(data)
    setIsVisible(true)
  }

  const handleStatusUpdate = (data: IUpdateApplicationStatusRequest) => {
    updateStatus(data)
  }
  return (
    <Container maxWidth='xl' sx={{ paddingTop: 4, paddingBottom: 8 }}>
      <Stack direction='row' justifyContent='space-between' mb={2} mr={1}>
        <Typography variant='h4' color='#1E90FF'>
          Applications
        </Typography>
        <Stack direction='row' alignItems='center'>
          <OutlinedInput
            placeholder='Search'
            onChange={(event) => setSearchKey(event.target.value)}
            endAdornment={
              <InputAdornment position='end'>
                <SearchIcon />
              </InputAdornment>
            }
            sx={{ marginRight: '20px' }}
          />
          <Button
            variant='outlined'
            sx={{ borderRadius: '20px', height: '40px', textDecoration: 'none' }}
            startIcon={<AddIcon />}
            onClick={() => {
              setIsVisible(true)
              setEditableApplication(undefined)
            }}
            size='medium'
          >
            Create
          </Button>
        </Stack>
      </Stack>
      <ApplicationTable
        rows={data ?? []}
        searchKey={searchKey}
        editApplication={(data) => handleEditable(data)}
        disableApplication={handleStatusUpdate}
      />
      <ApplicationForm
        open={isVisible}
        onClose={() => setIsVisible(false)}
        application={editableApplication}
        refetch={refetch}
      />
    </Container>
  )
}
